module.exports = __webpack_public_path__ + "img/wxgzh.d406afb0.png";